import { useAppDispatch } from "./reduxHooks";

import { alertActions } from "../features/alert/alertSlice";
import { switchToUser } from "../lib/api";
import {
    getTokenFromLocalStorage,
    getUserFromLocalStorage,
} from "../lib/utils";
import { IUser } from "../types/api";

const useUserSwitcher = () => {
    const dispatch = useAppDispatch();

    const handleUserSwitch = async (userId: IUser["id"]) => {
        const currentUser = getUserFromLocalStorage();
        const currentUserToken = getTokenFromLocalStorage();

        try {
            const response = await switchToUser(userId);

            localStorage.setItem(
                "originalUserData",
                JSON.stringify({
                    token: currentUserToken,
                    user: {
                        ...currentUser,
                    },
                }),
            );

            localStorage.setItem(
                "userData",
                JSON.stringify({
                    token: response.token,
                    user: {
                        ...response.user,
                    },
                    simulatingUser: true,
                }),
            );
            window.location.href = "/coachs-clubhouse";
        } catch (error: any) {
            localStorage.setItem(
                "userData",
                JSON.stringify({
                    token: currentUserToken,
                    user: {
                        ...currentUser,
                    },
                }),
            );
            dispatch(
                alertActions.error({
                    level: "danger",
                    title: "Switching users failed with the following error:",
                    text:
                        error +
                        "\n\nIf the problem persists, please contact the site admin.",
                    dismissible: true,
                }),
            );
        }
    };

    const handleExitUserSwitch = () => {
        const originalUserDataRaw = localStorage.getItem("originalUserData");
        const originalUserData =
            originalUserDataRaw && JSON.parse(originalUserDataRaw);
        localStorage.removeItem("originalUserData");
        localStorage.setItem(
            "userData",
            JSON.stringify({
                token: originalUserData.token,
                user: {
                    ...originalUserData.user,
                },
            }),
        );

        window.location.href = "/coachs-clubhouse";
    };

    const isSimulatingUser = (): boolean => {
        const originalUserData = localStorage.getItem("originalUserData");
        const userDataRaw = localStorage.getItem("userData");
        const userData = userDataRaw && JSON.parse(userDataRaw);

        if (originalUserData && userData?.simulatingUser) {
            return true;
        }

        return false;
    };

    return { handleUserSwitch, handleExitUserSwitch, isSimulatingUser };
};

export default useUserSwitcher;
